import { StyleSheet } from 'react-native';
import type { StylesMap } from 'Types';
import { Device } from 'DeviceUtils';

const styles: StylesMap = {
    miniPlayerDetail: {
        flex: 5
    },
    miniPlayerUIContainer: {
        // backgroundColor: '#3ee',
        position: 'absolute',
        left: '100%'
        // marginLeft: '45%'
    },
    alert: {
        width: '75%',
        marginHorizontal: '12.5%'
    },
    alertInnerContainerStyle: {}
};

if (Device.isTabletOrWeb) {
    styles.alert = {
        bottom: 'auto',
        width: '100%',
        top: 50,
        left: 'auto',
        /* right: 0; */
        /* display: flex; */
        justifyContent: 'center',
        alignItems: 'center',
        margin: 0,
        zIndex: 1000
    };
    styles.alertInnerContainerStyle = {
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
    };
}


export default StyleSheet.create(styles);
